import { c as _c } from "react/compiler-runtime";
import { useChains, useCurrencies } from "@opensea/app-kit";
import { createContext, useContext, useState } from "react";
import { useChainArch } from "../../../../polychain/hooks";
import { useChainId } from "../../../../polychain/hooks/useChainId";
const SendQuoteContext = createContext({
  currency: {},
  setCurrency: () => {}
});
export function SendProvider(t0) {
  const $ = _c(11);
  const {
    children
  } = t0;
  const chainId = useChainId();
  const chainArch = useChainArch();
  const {
    getNativeCurrency,
    getChainIdentifier
  } = useChains();
  const {
    getCurrencyStrict
  } = useCurrencies();
  const t1 = chainId ?? 1;
  let t2;
  if ($[0] !== chainArch || $[1] !== getChainIdentifier || $[2] !== getCurrencyStrict || $[3] !== getNativeCurrency || $[4] !== t1) {
    const chainIdentifier = getChainIdentifier(t1, chainArch);
    t2 = getCurrencyStrict(getNativeCurrency(chainIdentifier ?? "ethereum"));
    $[0] = chainArch;
    $[1] = getChainIdentifier;
    $[2] = getCurrencyStrict;
    $[3] = getNativeCurrency;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const nativeCurrency = t2;
  const [currency, setCurrency] = useState(nativeCurrency);
  let t3;
  if ($[6] !== currency) {
    t3 = {
      currency,
      setCurrency
    };
    $[6] = currency;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== t3) {
    t4 = <SendQuoteContext.Provider value={t3}>{children}</SendQuoteContext.Provider>;
    $[8] = children;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export const useSendQuote = () => {
  const context = useContext(SendQuoteContext);
  return context;
};